import React, {Component} from 'react';

class Article extends Component {


    render() {
        return (

            <div id="article" className="row home-block">

                <h2 className="title">Estimation</h2>
                <h3>Intervenante</h3>
                <p>Cours <a href="http://irma.math.unistra.fr/~mmaumy/index.html">Myriam Maumy Bertrant</a> - TD : <a
                    href="/#Menu">Emmanuelle Claeys</a></p>
                <h3>Description</h3>
                <p>Le but de ce cours est de comprendre les conceptes statistique qui interviennent en Machine Learning.<br/>
                    La théorie portera sur le vocabulaire probabiliste, les tests statistiques et les méthodes de
                    modèlisation<br/>
                    Les TD vous permetteront de savoir comment extraires des informations utiles d'une base de donnée,
                    utiliser un test statistique et mettre en place un modèle prédictif. <br/><br/>
                    Vous devriez, à la fin de ce cours, comprendre le travail d'un <span className="italique">data scientist</span>.
                </p>

                <h3>Cours et slides</h3>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/Cours1_4055_2017.pdf">Cours
                    1</a>
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/Cours2_4055_2017.pdf">Cours
                    2</a>
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/Cours3_4055_2017.pdf">Cours
                    3</a>
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/Cours5_4055_2017.pdf">Cours
                    5</a>
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/Cours6_4055_2017.pdf">Cours
                    6</a>
                </li>


                <h3>Travaux dirigés</h3>
                <li><a href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/td_0_intro_R.pdf">Prise en main
                    de R et R studio.</a>
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/TD1__4A2017v2.pdf">TD
                    1 </a> <a
                    href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/TD1_4055_2017_correction.R"> TD
                    1 correction</a> ,<a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/vgsales.csv"> données </a>.
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/TD2__4055_2017.pdf">TD
                    2</a>, <a
                    href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/TD2_4055_2017-correction.R">TD
                    2 correction</a>,<a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/presidential_polls.csv"> données </a>.
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/TD3_4055_2017.pdf">TD
                    3</a>, <a
                    href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/TD3_4055_2017_correction.R">TD
                    3 correction</a>,<a
                    href="https://github.com/manuclaeys/esiea_2019_laval/blob/master/MyData.csv"> données </a>.
                </li>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/TD_Bonus_4055_2017.pdf">TD
                    Bonus</a>, <a
                    href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/TD3_4055_2017_correction.R">TD
                    Bonus correction</a>.
                </li>


                <h3>Examen</h3>
                <li><a href="https://github.com/manuclaeys/esiea_estimation_2017/blob/master/Exam_4056.pdf">Sujet</a>
                </li>

                <h3>Bibliographie</h3>
                <li>Understanding Machine Learning, From Theory to Algorithms, <em> par Shai Shalev-Shwartz et Shai
                    Ben-David</em></li>
                <li>The Elements of Statistical Learning, <em>Trevor Hastie, Robert Tibshirani et Jerome Friedman</em>
                </li>
                <li>La chaine YouTube <a href="https://www.youtube.com/channel/UCWty1tzwZW_ZNSp5GVGteaA">La statistique
                    expliquée à mon chat</a>
                </li>
                <li>Verdel Thierry propose également une retransmission de ses cours que je trouve très bien faits <a
                    href="https://www.youtube.com/playlist?list=PLuM2VYvZJBe4HrTNBtTcgOb7zOsrRf55M">ici</a>
                </li>


                <h3>Retours étudiants</h3>
                <li> Les retours des étudiants sont visibles sur <a
                    href="https://docs.google.com/forms/d/e/1FAIpQLSckkqkdU9VMcjCdRK-6wHkQWYSdq9rP8iPcoeMHxWNyDT5SFQ/viewanalytics">ce
                    lien</a>.

                </li>

            </div>

        );
    }
}

export default Article;



// WEBPACK FOOTER //
// ./src/Components/CoursEstimation2018/index.js